import {
	Component,
	OnInit,
	Input,
	Output,
	EventEmitter,
	SimpleChanges,
	OnChanges,
} from "@angular/core";
import { DropSelectOption } from "../drop-select/drop-select.model";

@Component({
    selector: "mini-drop-select",
    templateUrl: "./mini-drop-select.component.html",
    styleUrls: ["./mini-drop-select.component.scss"],
    standalone: false
})
export class MiniDropSelectComponent implements OnInit, OnChanges {
	// Publics
	public showOptions = false;
	public touched = false;
	public optionExists = false;
	public hasError = false;
	public customErrorMessage: string;
	public activeOptionIndex = -1;
	// Inputs
	@Input() label = "/month";
	@Input() options: DropSelectOption[];
	@Input() defaultOption: DropSelectOption;
	@Input() required = false;
	// Outputs
	@Output() optionSelected = new EventEmitter();

	// Constructor
	constructor() {}

	// OnInit
	ngOnInit() {
		// Check for a default option on load
		if (this.defaultOption) {
			this.label = this.defaultOption.Value;
			this.optionExists = true;
			this.hasError = false;
		}
	}

	// OnChanges
	ngOnChanges(changes: any) {
		if (changes["defaultOption"] && this.defaultOption) {
			this.label = this.defaultOption.Value;
			this.optionExists = true;
			this.hasError = false;
		}
	}

	/**
	 * DROP-DOWN INTERACTIONS
	 */

	// Toggle showing and hiding the options
	public toggleOptions() {
		this.showOptions = !this.showOptions;

		// Set to touched on first toggle
		if (!this.touched) {
			this.touched = true;
		}

		// Check for an error on close via button
		if (!this.showOptions) {
			this.errorCheck();
		}
	}

	// Toggle showing options on blur
	public blurToggleOptions() {
		setTimeout(() => {
			if (this.showOptions) {
				this.showOptions = !this.showOptions;
				this.errorCheck();
			}
		}, 150);
	}

	// Select an option from the drop-down
	public selectDropOption(option: DropSelectOption) {
		this.hasError = false;
		this.optionExists = true;
		this.label = option.Value;
		this.optionSelected.emit(option);
		// Hide the drop-down options
		this.toggleOptions();
	}

	/**
	 * ERROR CHECKING
	 */

	// Check required error
	public errorCheck() {
		// Check for a required error in the drop-down
		if (this.required && this.touched && !this.optionExists) {
			this.hasError = true;
			this.customErrorMessage = "Please select an option";
			return;
		}
		// Default error state of false
		this.hasError = false;
	}
}
